function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M433.294,344.171c23.247-3.74,40.349-23.79,40.376-47.336v-48c0-4.418-3.582-8-8-8H241.534c-4.418,0-8,3.582-8,8v72 H217.67v-192c0.002-1.081-0.219-2.151-0.648-3.144L193.67,71.235v-38.4c0-4.418-3.582-8-8-8h-144c-4.418,0-8,3.582-8,8v38.4 l-23.352,54.48c-0.426,0.985-0.646,2.047-0.648,3.12v274.824c-10.984,8.626-12.895,24.523-4.269,35.507 c4.802,6.115,12.15,9.681,19.925,9.669H417.67c3.047,0.017,5.838-1.699,7.2-4.424l13.744-27.576h35.056v-16h-72.296 C419.558,387.319,431.158,366.727,433.294,344.171z M433.67,256.835h24v40c-0.055,14.547-9.914,27.227-24,30.864V256.835z M197.542,120.835h-23.744l11.872-27.688L197.542,120.835z M201.67,136.835v184h-32v-184H201.67z M49.67,40.835h128v24h-128 V40.835z M46.942,80.835h126.6l-17.144,40h-126.6L46.942,80.835z M25.67,136.835h128v184h-17 c-7.313-0.002-14.269,3.157-19.08,8.664c-2.048,2.393-3.628,5.15-4.656,8.128l-38.928,11.12 c-9.907,2.909-17.071,11.521-18.128,21.792L25.67,392.115V136.835z M25.326,432.835c-4.025,0.005-7.597-2.577-8.856-6.4 c-1.313-3.888,0.079-8.176,3.424-10.552l38.312-27.368l8.864,44.32H25.326z M83.382,432.835l-11.576-57.904 c-0.926-4.765,1.932-9.45,6.592-10.808l33.824-9.664l10.608,78.376H83.382z M138.982,432.835l-11.568-85.432 c-0.68-5.111,2.911-9.806,8.022-10.486c0.409-0.054,0.821-0.082,1.234-0.082h96.872c0.068,25.231,12.035,48.952,32.288,64h-64.16 v16h35.056l8,16H138.982z M420.726,416.835l-8,16H262.614l-8-16H420.726z M353.534,400.835H313.67 c-35.403-0.044-64.092-28.733-64.136-64.136v-79.864H417.67v79.864C417.631,372.104,388.939,400.795,353.534,400.835z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M321.534,368.835c-22.08-0.026-39.974-17.92-40-40v-8h-16v8c0.04,30.911,25.089,55.96,56,56h8v-16H321.534z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 265.534,
  y: 288.835,
  width: 16,
  height: 16
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M421.67,144.835h-96c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12h36c22.08-0.026,39.974-17.92,40-40h-16 c0,13.255-10.745,24-24,24h-36c-15.464,0-28,12.536-28,28s12.536,28,28,28h96c6.627,0,12,5.373,12,12c0,6.627-5.373,12-12,12h-116 c-22.08,0.026-39.974,17.92-40,40h16c0-13.255,10.745-24,24-24h116c15.464,0,28-12.536,28-28S437.134,144.835,421.67,144.835z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M89.67,176.835c-17.673,0-32,14.327-32,32s14.327,32,32,32s32-14.327,32-32S107.343,176.835,89.67,176.835z M89.67,224.835c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S98.507,224.835,89.67,224.835z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 57.67,
  y: 256.835,
  width: 64,
  height: 16
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 57.67,
  y: 288.835,
  width: 64,
  height: 16
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.67 473.67",
    style: {
      "enableBackground": "new 0 0 473.67 473.67"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

export default __webpack_public_path__ + "static/media/breakfast.8e78bac8.svg";
export { SvgComponent as ReactComponent };